"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const redux_logger_1 = require("redux-logger");
const redux_thunk_1 = require("redux-thunk");
const reducers_1 = require("./reducers");
const configureStore = () => {
    const middleware = [redux_thunk_1.default];
    if (process.env.NODE_ENV !== 'production') {
        const logger = redux_logger_1.createLogger();
        middleware.push(logger);
    }
    const enhancer = redux_1.applyMiddleware(...middleware);
    const store = redux_1.createStore(reducers_1.default, enhancer);
    return store;
};
exports.default = configureStore;
